module.exports = __webpack_public_path__ + "static/media/nlg.a879b0cc.svg";